module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('box-helper', {
    attrs: {
      "headline": "Overblik",
      "identifier": "index"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container section"
  }, [_c('title-block', {
    staticClass: "mb-xl",
    attrs: {
      "headline": "<b>Overblik</b>",
      "position": "center"
    }
  }, [_c('p', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("\n                Hvad skal der fokus på i dag?\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.$auth.user().roles[0].name !== 'department-responsible') ? _c('div', {
    staticClass: "economy-overview"
  }, [_c('div', {
    staticClass: "row nomargin"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            EBITDA året til dato\n                            "), _c('d-tooltip', {
    attrs: {
      "placement": "inline",
      "identifier": "index.ebitda"
    }
  })], 1), _vm._v(" "), (!_vm.$auth.user().name.includes('Demo')) ? _c('div', {
    staticClass: "number color__main"
  }, [(_vm.calculations && _vm.keyfigures.ebitda) ? _c('span', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(_vm.keyfigures.ebitda)) + "\n                            ")]) : _c('span', [_vm._v("-")])]) : _c('div', {
    staticClass: "number color__main"
  }, [_vm._v("\n                            " + _vm._s(_vm._f("currency")(324353)) + "\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            Forventet omsætning i denne måned\n                            "), _c('d-tooltip', {
    attrs: {
      "placement": "inline",
      "identifier": "index.expectedRevenue"
    }
  })], 1), _vm._v(" "), (!_vm.$auth.user().name.includes('Demo')) ? _c('div', {
    staticClass: "number color__good"
  }, [(_vm.calculations && _vm.keyfigures.expected_revenue !== undefined) ? _c('span', [(_vm.keyfigures.expected_revenue !== 0) ? _c('span', [_vm._v("\n                                    " + _vm._s(_vm._f("currency")(_vm.keyfigures.expected_revenue)) + "\n                                ")]) : _c('router-link', {
    staticClass: "small",
    staticStyle: {
      "color": "#fff",
      "margin": "0",
      "padding": "0",
      "cursor": "pointer"
    },
    attrs: {
      "tag": "span",
      "to": {
        name: 'Settings',
        params: {
          'selected': 'budget'
        }
      }
    }
  }, [_vm._v("\n                                    Læg budget nu "), _c('i', {
    staticClass: "fas fa-arrow-right"
  })])], 1) : _c('span', [_vm._v("-")])]) : _c('div', {
    staticClass: "number color__good"
  }, [_vm._v("\n                            " + _vm._s(_vm._f("currency")(538000)) + "\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            Forventede udgifter i denne måned\n                            "), _c('d-tooltip', {
    attrs: {
      "placement": "inline",
      "identifier": "index.expectedCosts"
    }
  })], 1), _vm._v(" "), (!_vm.$auth.user().name.includes('Demo')) ? _c('div', {
    staticClass: "number color__bad"
  }, [(_vm.calculations && _vm.keyfigures.expected_costs !== undefined) ? _c('span', [(_vm.keyfigures.expected_costs !== 0) ? _c('span', [_vm._v("\n                                    " + _vm._s(_vm._f("currency")(_vm.keyfigures.expected_costs)) + "\n                                ")]) : _c('router-link', {
    staticClass: "small",
    staticStyle: {
      "color": "#fff",
      "margin": "0",
      "padding": "0",
      "cursor": "pointer"
    },
    attrs: {
      "tag": "span",
      "to": {
        name: 'Settings',
        params: {
          'selected': 'budget'
        }
      }
    }
  }, [_vm._v("\n                                    Læg budget nu "), _c('i', {
    staticClass: "fas fa-arrow-right"
  })])], 1) : _c('span', [_vm._v("-")])]) : _c('div', {
    staticClass: "number color__bad"
  }, [_vm._v("\n                            " + _vm._s(_vm._f("currency")(493000)) + "\n                        ")])])])]) : _vm._e(), _vm._v(" "), _c('value-chain'), _vm._v(" "), _c('div', {
    staticClass: "number-overview"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-2"
  }, [_c('number-card', {
    attrs: {
      "heading": "Tilbud",
      "description": "der afventer afgørelse",
      "number": _vm.calculations.offer,
      "icon": "file-alt",
      "state": "avg",
      "linkParent": "ProjectsOperations",
      "linkChild": "offerProjects",
      "tooltipIdentifier": "index.offerProjects"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('number-card', {
    attrs: {
      "heading": "Opgaver",
      "description": "der endnu ikke er påbegyndt",
      "number": _vm.calculations.open,
      "icon": "inbox-in",
      "state": "avg",
      "linkParent": "ProjectsOperations",
      "linkChild": "openProjects",
      "tooltipIdentifier": "index.openProjects"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('number-card', {
    attrs: {
      "heading": "Igangværende opgaver",
      "description": "der arbejdes på lige nu",
      "number": _vm.calculations.ongoing,
      "icon": "clock",
      "state": "bad",
      "linkParent": "ProjectsOperations",
      "linkChild": "ongoingProjects",
      "tooltipIdentifier": "index.ongoingProjects"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('number-card', {
    attrs: {
      "heading": "Igangværende opgaver",
      "description": 'uden registreringer i ' + _vm.$store.state.config.companyMeta.settings.snoozed_days + ' dage ',
      "number": _vm.calculations.snoozed,
      "icon": "snooze",
      "state": "bad",
      "linkParent": "ProjectsOperations",
      "linkChild": "snoozedProjects",
      "tooltipIdentifier": "index.snoozedProjects"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('number-card', {
    attrs: {
      "heading": "Reklamationer",
      "description": "der ikke er afsluttet",
      "number": _vm.calculations.claims,
      "icon": "comment-exclamation",
      "state": "good",
      "linkParent": "ProjectsOperations",
      "linkChild": "openClaims",
      "tooltipIdentifier": "index.openClaims"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('number-card', {
    attrs: {
      "heading": "Afsluttede opgaver",
      "description": "der ikke er fakturerede",
      "number": _vm.calculations.unbilled,
      "icon": "envelope-open-dollar",
      "state": "avg",
      "linkParent": "ProjectsOperations",
      "linkChild": "noInvoiceProjects",
      "tooltipIdentifier": "index.unbilledProjects"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('number-card', {
    attrs: {
      "heading": "Fakturaer",
      "description": "der endnu ikke er betalt",
      "number": _vm.calculations.payment_pending,
      "icon": "envelope-open-dollar",
      "state": "avg",
      "linkParent": "EconomyOperations",
      "linkChild": "unpaidInvoices",
      "tooltipIdentifier": "index.unpaidInvoices"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('number-card', {
    attrs: {
      "heading": "Fakturaer",
      "description": 'hvor betaling er overskredet med ' + _vm.$store.state.config.companyMeta.settings.overdue_days + ' dage',
      "number": _vm.calculations.payment_exceeded,
      "icon": "calendar-exclamation",
      "state": "bad",
      "totalValue": _vm.calculations.payment_exceeded_total,
      "linkParent": "EconomyOperations",
      "linkChild": "exceededPayments",
      "tooltipIdentifier": "index.overdueInvoices"
    }
  })], 1)])])], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7dd1bf60", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7dd1bf60"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/index.vue
// module id = 866
// module chunks = 0